import { DISCLAIMER, type PrintProduct } from "@/shared/lib/printLayout";

interface PrintPosterProps {
  url: string;
  qrSrc: string;
  logoSrc: string;
  product: PrintProduct;
}

/**
 * Печатный макет A4 — единственный источник разметки: и для превью, и для печати.
 *
 * Как менять, когда придут правки от заказчика:
 * - тексты (слоганы, преимущества, названия продуктов) — PRINT_PRODUCTS в shared/lib/printLayout;
 * - юридический дисклеймер — DISCLAIMER там же;
 * - оформление (размеры, цвета, отступы) — PRINT_CSS там же, классы .a4-*;
 * - состав и порядок блоков — здесь: блоки идут сверху вниз, как на листе.
 */
export function PrintPoster({ url, qrSrc, logoSrc, product }: PrintPosterProps) {
  return (
    <div className="a4">
      <div className="a4-rule" />

      {/* шапка: логотип и название продукта */}
      <div className="a4-brand">
        <img src={logoSrc} alt="" />
        <span>{product.brand}</span>
      </div>

      {/* слоган в две строки, вторая — акцентным цветом */}
      <div className="a4-headline">
        {product.headline}
        <br />
        <em>{product.accent}</em>
      </div>

      {/* QR со ссылкой партнёра и сама ссылка текстом */}
      <img className="a4-qr" src={qrSrc} alt="QR-код" />
      <div className="a4-scan">Наведите камеру телефона на QR-код</div>
      <div className="a4-link">{url}</div>

      {/* блок преимуществ на голубой подложке */}
      <div className="a4-promo">
        <div className="a4-promo-title">
          {product.promoTitle}
          <em>{product.promoAccent}</em>
        </div>
        <ul className="a4-promo-list">
          {product.bullets.map((bullet) => (
            <li key={bullet}>{bullet}</li>
          ))}
        </ul>
      </div>

      <div className="a4-spacer" />

      {/* обязательная по закону о рекламе часть — не убирать */}
      <div className="a4-disclaimer">
        <span>{DISCLAIMER}</span>
        <span className="a4-badge">18+</span>
      </div>

      <div className="a4-rule" />
    </div>
  );
}
